import { Box, VStack } from '@chakra-ui/react'
import { Button } from 'uikit'
import { InputForm, TextAreaForm } from 'uikit'
import { Form } from 'uikit/layout'
import { Field, Formik } from 'formik'
import * as Yup from 'yup'

const formSchema = Yup.object({
  subject: Yup.string().required('Поле обязательно'),
})

export const ItemForm = ({ onSubmit, isLoading }) => {
  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      onSubmit={onSubmit}
      validationSchema={formSchema}
      validateOnMount
    >
      {(props) => {
        return (
          <Form>
            <VStack gap="20px">
              <Field
                name="subject"
                label="Номер карты/телефона"
                component={InputForm}
                disabled={isLoading}
              />
              <Field
                name="description"
                label="Комментарий"
                component={TextAreaForm}
                minHeight="100px"
                disabled={isLoading}
              />
            </VStack>

            <Box pt="30px">
              <Button
                onClick={() => props.handleSubmit()}
                colorPalette="orange"
                loading={isLoading}
                disabled={!props.isValid}
              >
                Добавить
              </Button>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}
